<template>
    <div class="surveillance">
        <topTitle class="top-title" :title="'移动能源运营监控调度大屏'">
            <template v-slot:topLeft>
                <span @click="cityShow = true">{{ cityName }}</span>
            </template>
        </topTitle>
        <right></right>
        <city
            :show.sync="cityShow"
            @upData="change" />
    </div>
</template>

<script>
import topTitle from '../components/topTitle.vue'
import right from "./surveillanceComponents/right.vue";
import city from './../components/city.vue'
export default {
    components: {
        topTitle,
        right,
        city
    },
    data() {
        return {
            cityShow: false,
            cityName: '全国',
            cityUpdate: null
        }
    },
    provide() {
        return {
            cityUpdate: () => this.cityUpdate
        }
    },
    mounted() {
        this.$EventBus.$emit('update', '')
    },
    methods: {
        change(data) {
            // debugger
            this.cityName = data.name
            this.cityUpdate = data
            // this.$nextTick( () => {
            //     this.$EventBus.$emit('update', data)
            // })
        }
    }
}
</script>